import {axios} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  findUnallocatedStudent({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`student/distribution/findUnallocatedStudent`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },



}
